import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const iconFolderOpen = <FontAwesomeIcon icon={faFolderOpen} color="#007e8d" size="sm" />;

export default iconFolderOpen;
